import {
  Box,
  Button,
  Container,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { useMemo, useState } from "react";
import { TailSpin } from "react-loader-spinner";
import { adminAxiosInstance, axiosInstance } from "src/api/axios";
import PageContainer from "src/components/container/PageContainer";

function OldReportPage() {
  const [leadData, setLeadData] = useState([]);
  const [fileName, setFileName] = useState([]);
  const [loader, setLoader] = useState(false);
  const [hide, setHide] = useState(false);
  const [error, setError] = useState([]);

  useMemo(() => {
    axiosInstance.get("/users").then((res) => {
      if (res.status < 210) {
        let _ = res.data;
        if (!_?.role.includes("admin")) {
          window.location.href = "/";
        }
      }
    });
  }, []);

  const parseCsv = (file, setter) => {
    setError([]);
    const fileName = file.name;
    const reader = new FileReader();
    reader.onload = (e) => {
      console.log({ file: e.target });
      const sheet = e.target.result;
      let rows = sheet.includes("\r\n")
        ? sheet.split("\r\n")
        : sheet.split("\n");
      let headers = rows[0].split(",");
      let acceptedHeaders = [
        "id",
        "user_id",
        "slab",
        "paid",
        "due_payment",
        "action_message",
        "action_header",
        "conversions",
        "status",
      ];
      let incorrectHeaders = headers.filter(
        (o) => !acceptedHeaders.includes(o)
      );
      if (incorrectHeaders.length) {
        setError((err) => [
          ...error,
          `Incorrect Headers found:\n${incorrectHeaders.join("\n")}`,
        ]);
        return;
      }
      let data = [];
      for (let r of rows.slice(1)) {
        let columns = r.split(",");
        let obj = {};
        for (let col in columns) {
          if (col && col in headers && headers[col]) {
            obj[headers[col].trim()] = columns[col];
          }
        }
        obj = JSON.parse(JSON.stringify(obj));

        data.push(obj);
      }
      setFileName(fileName);
      setLeadData(data);
    };
    reader.readAsText(file);
  };

  const submitLead = (source) => {
    setLoader(true);
    adminAxiosInstance
      .post("/reports/old-leads", { fileName, data: leadData })
      .then((response) => {
        setHide(false);
        setLoader(false);
        if ("status" in response && response.status >= 400) {
          alert("Something went wrong in saving report, please check CSV");
        } else {
          setLeadData([]);
          setFileName("");
        }
      })
      .catch((e) => {
        console.log(e);
        alert("Something went wrong");
      });
  };

  return (
    <PageContainer
      title="Upload Reports"
      description="this is Products Creation page for admins"
    >
      <Container>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h4">Upload Leads Report here</Typography>
          </Grid>
          {loader ? (
            <Stack alignItems={"center"} justifyContent={"center"}>
              <TailSpin
                height={45}
                width={45}
                style={{ margin: "auto", bg: "#444" }}
              />
            </Stack>
          ) : !leadData.length ? (
            <Grid item xs={12}>
              <Box boxShadow={5} borderRadius={5}>
                <Grid item xs={12}>
                  <Stack
                    direction="column"
                    spacing={1}
                    my={1}
                    p={2}
                    alignItems="center"
                    border={1}
                    borderColor={"#8769DC"}
                    borderRadius={5}
                  >
                    <label
                      htmlFor="LeadReport"
                      style={{
                        width: "80%",
                        background: "#eee",
                        borderRadius: "10px",
                        height: "180px",
                        display: "flex",
                        flexFlow: "column",
                        alignItems: "center",
                      }}
                    >
                      <Stack
                        direction="column"
                        spacing={2}
                        alignItems={"center"}
                        my={2}
                        py={3}
                      >
                        <h2>Upload Lead CSV sheet</h2>
                        <span>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M1.99967 9.33337C2.36786 9.33337 2.66634 9.63185 2.66634 10V12.6667C2.66634 12.8435 2.73658 13.0131 2.8616 13.1381C2.98663 13.2631 3.1562 13.3334 3.33301 13.3334H12.6663C12.8431 13.3334 13.0127 13.2631 13.1377 13.1381C13.2628 13.0131 13.333 12.8435 13.333 12.6667V10C13.333 9.63185 13.6315 9.33337 13.9997 9.33337C14.3679 9.33337 14.6663 9.63185 14.6663 10V12.6667C14.6663 13.1971 14.4556 13.7058 14.0806 14.0809C13.7055 14.456 13.1968 14.6667 12.6663 14.6667H3.33301C2.80257 14.6667 2.29387 14.456 1.91879 14.0809C1.54372 13.7058 1.33301 13.1971 1.33301 12.6667V10C1.33301 9.63185 1.63148 9.33337 1.99967 9.33337Z"
                              fill="#3C50E0"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M7.5286 1.52864C7.78894 1.26829 8.21106 1.26829 8.4714 1.52864L11.8047 4.86197C12.0651 5.12232 12.0651 5.54443 11.8047 5.80478C11.5444 6.06513 11.1223 6.06513 10.8619 5.80478L8 2.94285L5.13807 5.80478C4.87772 6.06513 4.45561 6.06513 4.19526 5.80478C3.93491 5.54443 3.93491 5.12232 4.19526 4.86197L7.5286 1.52864Z"
                              fill="#3C50E0"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M7.99967 1.33337C8.36786 1.33337 8.66634 1.63185 8.66634 2.00004V10C8.66634 10.3682 8.36786 10.6667 7.99967 10.6667C7.63148 10.6667 7.33301 10.3682 7.33301 10V2.00004C7.33301 1.63185 7.63148 1.33337 7.99967 1.33337Z"
                              fill="#3C50E0"
                            />
                          </svg>
                        </span>
                        <p>
                          <span className="text-primary">
                            Click to upload or drag and drop
                          </span>
                        </p>
                      </Stack>
                      <TextField
                        sx={{
                          display: "none",
                          paddingY: "45px",
                          width: "100%",
                        }}
                        id="LeadReport"
                        label="Lead CSV"
                        variant="outlined"
                        type="file"
                        value={leadData || []}
                        inputProps={{
                          accept: ".csv",
                        }}
                        onChange={(e) => parseCsv(e.target.files[0])}
                      />
                    </label>
                  </Stack>
                </Grid>
              </Box>
              {error.length ? (
                <Box boxShadow={5} borderRadius={5}>
                  <Typography p={4}>{error}</Typography>
                </Box>
              ) : null}
            </Grid>
          ) : (
            <Grid item xs={12} my={3}>
              <TableContainer
                component={Box}
                boxShadow={15}
                borderRadius={7}
                sx={{ overflow: "hidden" }}
              >
                <Table
                  stickyHeader={true}
                  sx={{ borderBottom: "1px solid #777a" }}
                >
                  <TableHead sx={{}}>
                    <TableRow>
                      {Object.keys(leadData[0]).map((row, index) => {
                        return (
                          <TableCell
                            key={index}
                            sx={{ borderBottom: "1px solid " }}
                            component={"th"}
                          >
                            {row}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {leadData.map((row) => {
                      return (
                        <TableRow sx={{ border: "1px solid " }}>
                          {Object.values(row).map((col, index) => {
                            return <TableCell key={index}>{col}</TableCell>;
                          })}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
                <Stack
                  direction={"row"}
                  justifyContent={"center"}
                  spacing={4}
                  my={3}
                >
                  <Button
                    size={"large"}
                    variant={"outlined"}
                    sx={{ margin: "0 50%" }}
                    onClick={() => {
                      setLeadData([]);
                      setFileName("");
                    }}
                  >
                    Cancel
                  </Button>
                  {!hide ? (
                    <Button
                      size={"large"}
                      variant={"contained"}
                      sx={{ margin: "0 50%" }}
                      onClick={() => {
                        setHide(true);
                        submitLead();
                      }}
                    >
                      Submit
                    </Button>
                  ) : null}
                </Stack>
              </TableContainer>
            </Grid>
          )}
        </Grid>
      </Container>
    </PageContainer>
  );
}

export default OldReportPage;
